import Swiper from 'swiper';
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';
        
        let config = {
            modules: [ A11y, Autoplay, EffectFade, Pagination ],

            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }



        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper', config);
            function offset(el) {
                let rect = el.getBoundingClientRect(),
                    scrollLeft = window.scrollX  || document.documentElement.scrollLeft,
                    scrollTop = window.scrollY || document.documentElement.scrollTop;
                return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
            }
            let NewsTopPosition = offset(document.querySelector('.news__title '));
            
            window.addEventListener('scroll', function() {
                if(window.scrollY > NewsTopPosition.top) {
                    swiperHome.autoplay.pause();
                    // console.log("pause");
                }
                else {
                    swiperHome.autoplay.resume()
                    // console.log("resume");
                }
            })
        }
        
    }


    //======================================================================================================
	// Slider Actus
	//======================================================================================================
	let newsSection = document.querySelector('.news .swiper');

	if (newsSection) {

        let nbSlides = document.querySelectorAll('.news .swiper .swiper-slide').length;
        let progressBar = document.querySelector(".autoplay-progress__bar");
        

        // Media (image or video) swiper
        let newsConfig = {
            modules: [ A11y, Autoplay, EffectFade, Navigation ],

            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            centeredSlides: true,
            speed: 800,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },

            on: {

                // Progress bar
                autoplayTimeLeft(s, time, progress) {
                    progressBar.style.width = ("--progress",(1 - progress) * 100) + "%";
                },

                // Functions init
                init: function () {

                    // Variables
                    let slidesA = document.querySelectorAll('.news .swiper-slide-active');
                    
                    // Function
                    slidesA.forEach(function (slide) {
                        let cacheA = slide.querySelector('.cache__img');
                        // console.log("coucou c'est la cache active", cacheA);
                        cacheA.style.transform = "translateX(-100%)";
                        // console.log('pas caché');
                    });

                    // Variables
                    let navigationArrowsNews = document.querySelectorAll('.news__nav__item');
                    let caches = document.querySelectorAll('.cache__img');

                    // Function
                    navigationArrowsNews.forEach(function (arrow) {
                        arrow.addEventListener('click', function () {

                            caches.forEach(function (cache) {
                                cache.style.transition = "0s";
                                cache.style.transitionDelay = "0s";
                            });
                            
                            // if (arrow.classList.contains('news__nav__next')) {
                            //     // console.log('next');
                            // } else if (arrow.classList.contains('news__nav__prev')) {
                            //     // console.log('prev');
                            // }
                        });
                    });
                }, 
                
                // Functions when slide change
                transitionStart: function() {

                    // console.log('transitionStart');

                    let slides = document.querySelectorAll('.news__item');

                    slides.forEach(function (slide) {

                        // Variables
                        let caches = slide.querySelectorAll('.cache__img');
                        // console.log(caches);
                        caches.forEach(function (cache) {
                            cache.style.transform       = "translateX(0)";
                            cache.style.transition      = "transform .5s cubic-bezier(.75,0,.175,1)";
                            cache.style.transitionDelay = ".5s";

                            // console.log('caché');
                        });
                    });

                    let slidesA = document.querySelectorAll('.news .swiper-slide-active');

                    slidesA.forEach(function (slide) {
                        let cacheA = slide.querySelector('.cache__img');
                        cacheA.style.transform          = "translateX(-100%)";
                        cacheA.style.transition         = "transform .5s cubic-bezier(.75,0,.175,1)";
                        cacheA.style.transitionDelay    = ".5s";

                        // console.log('pas caché');
                    });
                }
    
            },

            navigation: {
                nextEl: `.news__nav__next`,
                prevEl: `.news__nav__prev`,
            },
        };

        if(nbSlides > 1) {
            let news = new Swiper('.news .swiper', newsConfig);
        }
	}


    //======================================================================================================
	// Slider Events
	//======================================================================================================
	let eventsSection = document.querySelector('.events .swiper');
    
    if (eventsSection) {
        let eventsSlides = document.querySelectorAll('.events .swiper .swiper-slide').length;

        let eventsConfig = {
            modules: [ A11y, Navigation ],

            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop : false,

            slidesPerView: 1,
            spaceBetween: 0,

            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                }
            },

            navigation: {
                nextEl: `.events__nav__next`,
                prevEl: `.events__nav__prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(eventsSlides >= 2) {
            let swiperEvents = new Swiper('.events .swiper', eventsConfig);
        }
    }

}
